const SearchFormActions = {
    DEEP_LINKED_SEARCH: "search-form/deep-linked-search",
    INITIALIZE_CONTEXT: "search-form/initialize-context",
    INITIATE_SEARCH: "search-form/initiate-search",
    INITIATE_SEARCH_AND_SAVE_DEFAULT: "search-form/initiate-search-and-save-default",
    RESTORE_DEFAULT_AND_INITIATE_SEARCH: "search-form/restore-default-and-initiate-search",
    SELECT_STEREOTYPE: "search-form/select-stereotype",
    CLEAR_FIELDS: "search-form/clear-fields",
    SET_FIELD: "search-form/set-field",
    SET_USE_RELATIVE_DATES: "search-form/set-use-relative-dates",
    SORT: "search-form/sort",
    SELECT_PAGE: "search-form/select-page",
    SET_PAGE_SIZE: "search-form/set-page-size",
    SELECT_RESULT: "search-form/select-result",
};

export default SearchFormActions;



// WEBPACK FOOTER //
// ./app/data/SearchFormActions.js